import React from 'react';
import Typography from '@mui/material/Typography'

import { ReactTableServerSide } from '../../../ReactTableServerSide';
import { CsvButton } from '../../../../service/CsvButton';


const SmallTable = (props) => {

    return(
        <React.Fragment>
            <Typography variant={"h6"}>  {props.title} </Typography>

            <ReactTableServerSide
                headers={props.columnsData.headers}
                columns={props.columnsData.columns}
                data={props.columnsData.data}
                pagination={ props.columnsData.pagination }
                loadTableData={props.loadTableData}  
                loading={props.statusContents.pagination.loadData}
                height={260}
                showPagination={false}
            />

            <CsvButton getCsvData={props.getCsvData} />
        </React.Fragment> 
    );
}

export default SmallTable;